import { InscriptionCandidate } from '@/Domain/Entities';
import { InscriptionModules, InscriptionStatus, ProcessPhases } from '@/Domain/enum';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MdDatepicker } from '@/Components';

@Component({
    name: 'registry-day-section',
    components: { MdDatepicker }
})
export default class RegistryDaySection extends Vue {
    @Prop() readonly isEditMode!: boolean;
    @Prop() readonly isDraftMode!: boolean;
    @Prop() readonly isAdminRole!: boolean;
    @Prop() readonly isAnyModuleEditing!: boolean;
    @Prop() readonly processPhase!: number;
    @Prop() readonly inscription!: InscriptionCandidate;

    InscriptionStatus = InscriptionStatus;
    ProcessPhases = ProcessPhases;

    $refs!: {
        registryDay: HTMLElement;
    };

    setEditMode() {
        this.$emit('setEditMode', InscriptionModules.enum.DAYOFREGISTRY);
    }

    onSaveEditedRegistryDay() {
        this.$emit('edit', InscriptionModules.enum.DAYOFREGISTRY, this.$refs.registryDay);
    }

    cancelEditMode() {
        this.$emit('cancelEdit', InscriptionModules.enum.DAYOFREGISTRY);
    }

    onChangeRegistryDay(value: any) {
        this.$emit('update:inscription', new InscriptionCandidate(
            {
                ...this.inscription.toServer(),
                inscriptionDate: value
            }));
    }
}
